import { Injectable } from '@angular/core';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import { NewProFormPayload } from '../../types/payloads/proforms.payloads';

@Injectable({
  providedIn: 'root',
})
export class ProformsFormListService {
  constructor(private apiService: APICoreService) {}

  getForms(
    districtId?: number,
    pageSize = 10,
    page?: number,
    type?: string,
    status?: string
  ) {
    const params: {
      district_id?: number;
      per_page: number;
      page?: number;
      type?: string;
      status?: string;
      expand: string;
    } = {
      per_page: pageSize,
      expand: 'submissionCount,district',
    };

    if (districtId !== undefined) {
      params.district_id = districtId;
    }

    if (page !== undefined) {
      params.page = page;
    }

    if (type) {
      params.type = type;
    }

    if (status) {
      params.status = status;
    }

    return this.apiService.getRequest('growelab/pro-forms/forms', params);
  }

  createForm(payload: NewProFormPayload) {
    return this.apiService.postRequest('growelab/pro-forms/forms', payload);
  }

  getFormSubmissions(formId: number, pageNumber = 1) {
    return this.apiService.getRequest(
      `growelab/pro-forms/${formId}/submissions?expand=user.profile&page=${pageNumber}`
    );
  }
}
